<clr-modal
  #repModal
  [clrModalOpen]="modalOpen()"
  (clrModalOpenChange)="modalOpen.set($event)"
  [clrModalClosable]="true"
  [clrModalSize]="'full-screen'"
  class="h-100-stop">
  <h3 class="modal-title">
    {{ 'Replikat für Benutzer erstellen' | mrTranslate }}
    <clr-toggle-container clrInline class="nym margin-12-l" style="display: inline-flex">
      <clr-toggle-wrapper>
        <input clrToggle type="checkbox" [(ngModel)]="isForSelf" [ngModelOptions]="{ standalone: true }" />
        <label>{{ 'für sich' | mrTranslate }}</label>
      </clr-toggle-wrapper>
    </clr-toggle-container>
  </h3>
  <div class="modal-body d-f col h-100" [style.--user-btn-height]="isForSelf() ? '30px' : '150px'">
    @if (!isForSelf() && users().columns.length) {
      @let hideArr =
        ['kprolid', 'userimagebase64', 'rechte', 'eisenbahnbetriebsleiter (ebl)', 'anlagenverantwortlicher (alv)'];
      <clr-datagrid
        class="datagrid-compact"
        style="flex: 0 1 450px"
        [clrDgSelectionType]="'single'"
        [clrDgSelected]="[selectedUser()]"
        (clrDgSelectedChange)="selectedUser.set($event[0])"
        [clrDgItemsIdentityFn]="row => row?.id"
        [clrDgRowSelection]="true">
        @for (column of users().columns; track column.id) {
          <clr-dg-column [clrDgField]="column.id">
            <ng-container *clrDgHideableColumn="{ hidden: column.id | hideIDColumns: hideArr }">
              {{ column.id | titlecase | mrTranslate }}
            </ng-container>
          </clr-dg-column>
        }
        <clr-dg-row *clrDgItems="let row of users().rows" [clrDgItem]="row">
          @for (cell of users().columns; track cell.id) {
            <clr-dg-cell class="name-cell">{{ row[cell.id] | tablePrettyPrint }}</clr-dg-cell>
          }
        </clr-dg-row>
        <clr-dg-footer>{{ users().rows.length }} {{ 'Zeilen' | mrTranslate }}</clr-dg-footer>
      </clr-datagrid>
    }

    @if (isLoading()) {
      <div class="centred margin-5-t" style="height: 90px; width: fit-content"><clr-spinner /></div>
    }

    @if (wartungen().columns.length) {
      <div class="btn-group btn-icon btn-sm margin-5-t">
        <app-all-selected-btn
          [(selected)]="selectedWartungen"
          [all]="filterStore.filteredRows()"
          [position]="'bottom-right'" />
        @if (wartungen().rows.length != filterStore.filteredRows().length) {
          <button class="btn" (click)="filterStore.deleteAllFilters()">
            {{ 'Alle Filter zurücksetzen' | mrTranslate }}
          </button>
        }
        @if (savedSelected().length) {
          <button class="btn" (click)="selectedWartungen.set([]); savedSelected.set([])">
            {{ 'Auswahl zurücksetzen' | mrTranslate }}
          </button>
        }
      </div>
      <div class="d-f gap-5" style="flex: 1 0 550px; max-height: calc(100% - var(--user-btn-height))">
        <clr-datagrid
          id="objDg"
          class="datagrid-compact"
          style="flex: 3 3 150px"
          [clrDgSelectionType]="'multi'"
          [clrDgSelected]="selectedWartungen()"
          (clrDgSelectedChange)="selectedWartungen.set($event)"
          [clrDgRowSelection]="true"
          [clrDgItemsIdentityFn]="row => row?.ID">
          <clr-dg-column class="mw-0" clrDgField="typ">
            @let column = { id: 'typ', type: 'string' };
            <clr-dg-filter [attr.data-test-id]="'datagrid-repwartsetup-col-filter-' + column.id">
              <app-column-filter
                #wartungenFilter
                [column]="column"
                [objektTypIconValue]="filterStore.iconMap()"
                [uniqueColumnValues]="filterStore.uniqueValues()[column.id]"
                (changes)="filterStore.onChange($event)" />
            </clr-dg-filter>
            <ng-container>{{ 'Typ' | mrTranslate }}</ng-container>
          </clr-dg-column>
          @for (column of wartungen().columns; track column.id) {
            <clr-dg-column [clrDgField]="column.id" [clrDgSortOrder]="column.id == 'nextDatum' ? 1 : 0">
              @let title =
                column.id == 'nextDatum' ? 'Nächste Wartung'
                : column.id == 'letzteDatum' ? 'Letzte Wartung'
                : column.id == 'diffFromNow' ? 'Fälligkeit in Tagen'
                : null;
              <clr-dg-filter [attr.data-test-id]="'datagrid-repwartsetup-col-filter-' + column.id">
                <app-column-filter
                  #wartungenFilter
                  [column]="column"
                  [title]="title"
                  [objektTypIconValue]="filterStore.iconMap()"
                  [uniqueColumnValues]="filterStore.uniqueValues()[column.id]"
                  (changes)="filterStore.onChange($event)" />
              </clr-dg-filter>

              <ng-container
                *clrDgHideableColumn="{
                  hidden:
                    column.id | hideIDColumns: ['strbez', 'wid', 'mid', 'pid', 'icon', 'revbild', 'archiv_mid', 'typ'],
                }">
                {{ title ?? (column.id | titlecase) | mrTranslate }}
              </ng-container>
            </clr-dg-column>
          }
          <ng-template
            clrVirtualScroll
            let-row
            [clrVirtualRowsOf]="filterStore.filteredRows()"
            [clrVirtualRowsTrackBy]="(_, row) => row?.ID">
            <clr-dg-row [clrDgItem]="row" [clrDgSelectable]="row.mID > 0">
              <clr-dg-cell class="mw-0">
                <cds-icon
                  size="26"
                  class="grid-icon fill-black"
                  [title]="row.typ"
                  [shape]="row.icon ? 'objekttyp' + row.icon : 'unknown-status'" />
              </clr-dg-cell>
              @for (cell of wartungen().columns; track cell.id) {
                @if (cell.id == 'diffFromNow') {
                  <clr-dg-cell class="name-cell" [class.invalid-red]="row.diffFromNow < 3">
                    {{ row.diffFromNow }} &nbsp;
                    @if (row.diffFromNow < 0) {
                      <cds-icon class="grid-icon invalid-red" size="20" shape="exclamation-triangle" />
                    }
                  </clr-dg-cell>
                } @else {
                  <clr-dg-cell class="name-cell">{{ row[cell.id] | tablePrettyPrint | mrTranslate }}</clr-dg-cell>
                }
              }
            </clr-dg-row>
          </ng-template>
          <clr-dg-footer>{{ filterStore.filteredRows().length }} {{ 'Zeilen' | mrTranslate }}</clr-dg-footer>
        </clr-datagrid>

        <div class="datagrid-compact" style="flex: 1 1 150px">
          <div class="grid datagrid" id="saved-grid-container">
            <div class="border-table h-100 scroll">
              @let ignoreCols = ['strbez', 'wid', 'mid', 'pid', 'icon', 'revbild', 'archiv_mid', 'typ'];
              <table class="table margin-0-t table-compact">
                <thead style="position: sticky; top: -1px; z-index: 3">
                  <tr>
                    <th class="left name-cell">{{ 'Löschen' | mrTranslate }}</th>

                    <th class="left name-cell">{{ 'Typ' | mrTranslate }}</th>
                    @for (column of wartungen().columns; track column.id) {
                      @let title =
                        column.id == 'nextDatum' ? 'Nächste Wartung'
                        : column.id == 'letzteDatum' ? 'Letzte Wartung'
                        : column.id == 'diffFromNow' ? 'Fälligkeit in Tagen'
                        : null;
                      @if (!(column.id | hideIDColumns: ignoreCols)) {
                        <th class="left name-cell">{{ title ?? (column.id | titlecase) | mrTranslate }}</th>
                      }
                    }
                  </tr>
                </thead>
                <tbody>
                  @for (row of savedSelected(); track row.ID) {
                    <tr>
                      <td class="left name-cell">
                        <button
                          class="btn btn-link w-h-auto"
                          (click)="deleteFromSaved($index)"
                          [title]="'vom Auswahl löschen' | mrTranslate">
                          <cds-icon shape="times" />
                        </button>
                      </td>
                      <td>
                        <cds-icon
                          class="grid-icon fill-black"
                          [title]="row['icon']"
                          size="28"
                          [shape]="row['icon'] ? 'objekttyp' + row['icon'] : 'unknown-status'" />
                      </td>
                      @for (cell of wartungen().columns; track cell.id) {
                        @if (cell.id == 'diffFromNow') {
                          <td class="left name-cell" [class.invalid-red]="row.diffFromNow < 3">
                            {{ row.diffFromNow }} &nbsp;
                            @if (row.diffFromNow < 0) {
                              <cds-icon class="grid-icon invalid-red" size="20" shape="exclamation-triangle" />
                            }
                          </td>
                        } @else if (!(cell.id | hideIDColumns: ignoreCols)) {
                          <td class="left name-cell">{{ row[cell.id] | tablePrettyPrint | mrTranslate }}</td>
                        }
                      }
                    </tr>
                  }
                </tbody>
              </table>
            </div>
            <div class="datagrid-footer">
              <span class="datagrid-footer-select">
                <cds-icon size="18" shape="checkbox-list" />
                &nbsp;{{ savedSelected().length }}
              </span>
            </div>
          </div>
        </div>
      </div>
    }
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="replicate()" [disabled]="!savedSelected().length">
      {{ 'Erstellen' | mrTranslate }}
    </button>
    <button type="button" class="btn" (click)="repModal.close()">
      {{ 'Abbrechen' | mrTranslate }}
    </button>
  </div>
</clr-modal>
